import Axios, { type AxiosInstance, type AxiosPromise } from 'axios';
import { type IBookingsTokenResponse } from '../../types/bookings/bookings';

export const BookingsTokenServiceAxiosInstance: AxiosInstance = Axios.create({
	baseURL: window.lt.api.apimUrl,
	headers: {
		'Ocp-Apim-Subscription-Key': window.lt.api.apimKey
	}
});

class BookingsTokenService {
	axiosInstance: AxiosInstance = BookingsTokenServiceAxiosInstance;

	getToken(): AxiosPromise<IBookingsTokenResponse> {
		return this.axiosInstance.post('tour-bookings/token');
	}
}

export const bookingsTokenService = new BookingsTokenService();
